// The one modal: any element with data-modal-open="<dialog id>" opens that <dialog class="modal">.
// Closes with its close button, Escape, or a click on the backdrop (unless data-overlay-close="false").
(() => {
  if (window.themeModal) return;
  window.themeModal = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-modal-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.modalOpen);
      if (dialog?.showModal) {
        event.preventDefault();
        // still closing (clicked again quickly): stay open instead of closing a moment later
        if (!window.theme?.motion?.reopen?.(dialog) && !dialog.open) dialog.showModal();
        document.documentElement.classList.add('modal-lock');
      }
      return;
    }
    const dialog = event.target.closest('dialog.modal');
    if (!dialog) return;
    if (event.target.closest('[data-modal-close]') || (event.target === dialog && dialog.dataset.overlayClose !== 'false')) close(dialog);
  });

  // Fades and slides down like it came in (assets/motion.js), also on Escape.
  const close = (dialog) => {
    const motion = window.theme?.motion;
    if (!motion) { dialog.close(); return; }
    motion.closeDialog(dialog, [{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(16px) scale(0.98)' }], 200);
  };
  document.addEventListener('cancel', (event) => {
    if (!event.target.matches?.('dialog.modal')) return;
    event.preventDefault();
    close(event.target);
  }, true);

  // The close event comes a moment later: when one modal hands over to the next (Ingredient arrows, tracker), or the
  // bundle builder drawer still holds the lock, the page stays locked.
  document.addEventListener('close', (event) => {
    if (!event.target.matches?.('dialog.modal') || document.querySelector('dialog.modal[open], bundle-builder[data-open]')) return;
    document.documentElement.classList.remove('modal-lock');
  }, true);
})();
